import { useCallback, useEffect, useMemo, useState } from "react";
import {
  AGE_GATE_COOKIE_KEY,
  AGE_GATE_VERSION,
} from "../Constants/ageGate";
import { getCookie, removeCookie, setCookie } from "../Share/Func/Cookie";

function safeParseAgeGatePayload(rawValue) {
  if (!rawValue) return null;
  try {
    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== "object") return null;
    const v = Number(parsed.v);
    if (!Number.isFinite(v)) return null;
    const at = typeof parsed.at === "string" ? parsed.at : null;
    return { v, at };
  } catch {
    return null;
  }
}

export default function useAgeGate() {
  const payload = useMemo(() => {
    const raw = getCookie(AGE_GATE_COOKIE_KEY);
    return safeParseAgeGatePayload(raw);
  }, []);

  const [verified, setVerified] = useState(false);

  useEffect(() => {
    setVerified(Boolean(payload && payload.v === AGE_GATE_VERSION));
  }, [payload]);

  const confirm = useCallback(() => {
    const payload = { v: AGE_GATE_VERSION, at: new Date().toISOString() };
    setCookie(AGE_GATE_COOKIE_KEY, JSON.stringify(payload), {
      path: "/",
      sameSite: "Lax",
    });

    setVerified(true);
  }, []);

  useEffect(() => {
    // If we migrated from a persistent cookie (previous versions), remove it
    // by overwriting with session cookie on next confirm. Nothing to do here.
    // Keep helper to allow manual reset if needed in future.
    void removeCookie;
  }, []);

  return { verified, confirm };
}

